import styled from "@emotion/styled";
var TabContainer = /*#__PURE__*/ styled("div", {
    target: "e1cui5o00"
})("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";grid-column:span 12 / span 12;");
export { TabContainer };
